import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CircleChatService {

  constructor() { }

  // GET AND CHANGE MESSAGE RETURNED FROM SOCKET 
  checkSocketResponseMessage(response,userList) {
    let message = response.message;
    for (let i = 0; i < message.length; i++) {
      for (let j = 0; j < userList.length; j++) {
        const regex = "[[" + userList[j]["userId"] + "]]";
        message = message.replaceAll(
          regex,
          "<span class='_label'>" +
            "@" +
            userList[j]["fullName"] +
            "</span>"
        );
      }
      for (let k = 0; k < response.taggedStudies.length; k++) {
   
        const regex = "[[" + response.taggedStudies[k]["studyId"] + "]]";
        message = message.replaceAll(
          regex,
          `<a href="${response.taggedStudies[k]["redirectUrl"]}" target="_blank">
         <span class="_label1"> #StudyId: ${response.taggedStudies[k]["studyNumber"]} </span> </a>`);
      }
      for (let l = 0; l < response.taggedPatients.length; l++) {
      
        const regex = "[[" + response.taggedPatients[l]["patientId"] + "]]";
        message = message.replaceAll(regex,`<a href="${response.taggedPatients[l]["redirectUrl"]}" target="_blank">
         <span class="_label2"> #patient: ${response.taggedPatients[l]["patientIdentifier"]} </span> </a>`);
      }
    }
    return message;
  }

  // CHECK AND REPLACE USERID's FROM API TO MENTION TAG MESSAGE
  // checkApiMessageResponse(chat) {
  //   for (let i = 0; i < chat.length; i++) {
  //     let message = chat[i]["message"];
  //     for (let j = 0; j < chat[i]["taggedUsers"].length; j++) {
  //       const regex = "[[" + chat[i]["taggedUsers"][j]["userId"] + "]]";
  //       message = message.replaceAll(regex,"<span class='_label'>" + "@" + chat[i]["taggedUsers"][j]["fullName"] + "</span>");
  //     }
  //     for (let k = 0; k < chat[i]["taggedStudies"].length; k++) {
  //       const regex = "[[" + chat[i]["taggedStudies"][k]["studyId"] + "]]";
  //       message = message.replaceAll(regex,"<span class='_label1'>" + "#StudyID:" + " " + chat[i]["taggedStudies"][k]["studyNumber"] + "</span>");
  //     }
  //     for (let l = 0; l < chat[i]["taggedPatients"].length; l++) {
  //       const regex = "[[" + chat[i]["taggedPatients"][l]["patientId"] + "]]";
  //       message = message.replaceAll(regex,"<span class='_label2'  (click)='clickedPatient(chat[i]['taggedUsers'][j]['redirectUrl'])'>" +  "#PatientID:" + " " + chat[i]["taggedPatients"][l]["patientIdentifier"] + "</span>");
  //     }
  //     chat[i]["message"] = message;
  //   }
  //   return chat
  // }

}
